const commercialStatus = {
  preAccepted: '1',
  accepted: '2',
  preRejected: '3',
  rejected: '4',
  partialClaim: '5',
  totalClaim: '6',
  receiptOfGoods: '7',
  acceptedByDefault: '8',
  noAction: '0'
};

const siiStates = {
  created: '0',
  pendingShipping: '1',
  sent: '2',
  sendError: '3',
  accepted: '4',
  acceptedWithQualms: '5',
  rejected: '6',
  pendingConsultation: '7',
  queryError: '8',
  overcast: '9',
  canceled: '10',
  pendingValidation: '20',
};

const systemStatusCode = {
  created: '0',
  rejected: '1',
  reparos: '2',
  accepted: '10',
  pendingApproval: '15',
  closed: '100'
};

const docType = [
  { type: '801', label: 'Orden de compra' },
  { type: '803', label: 'Contrato' },
  { type: 'ACRE', label: 'Acta de recepción' },
  { type: 'AGD', label: 'Devolución de garantía' },
  { type: 'AGR', label: 'Recepción de Garantía' },
  { type: 'APR', label: 'Acta de aprobación' },
  { type: 'BTG', label: 'Boleta de garantía' },
  { type: 'C_HITO', label: 'Hito' },
  { type: 'CFZ', label: 'Solicitud de Compra' },
  { type: 'CHN', label: 'Solicitud de Compra' },
  { type: 'EPG', label: 'Estado de Pago' },
  { type: 'GOT', label: 'GOT' },
  { type: 'HEM', label: 'Hoja de entrega de materiales (HEM)' },
  { type: 'HES', label: 'Hoja de entrega de servicios (HES)' },
  { type: 'LIC', label: 'Licitación' },
  { type: 'MEMO', label: 'Memorándum electrónico' },
  { type: 'MP', label: 'Orden de compra de Mercado Público' },
  { type: 'PLZ', label: 'PLZ' },
  { type: 'PRY', label: 'Proyecto' },
  { type: 'RD1', label: 'Rendicion de financiamiento' },
  { type: 'RD2', label: 'Rendicion de gastos' },
  { type: 'SCO', label: 'Solicitud de Compra' },
  { type: 'SWF', label: 'SWF' },
];

const documents = {
  milestone: 'C_HITO',
  electronicMemorandum: 'MEMO',
  project: 'PRY',
};

export default {
  commercialStatus,
  siiStates,
  systemStatusCode,
  docType,
  documents
};
